<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Клиентские пуши</strong>
                </CCardHeader>
                <CCardBody>
                    <CRow class="pl-3 pb-3" />

                    <CForm>
                        <Pushes
                            :entity="{ pushes }"
                            :type="BUSINESS_TYPE.RESTAURANT"
                            all-pushes
                            @save="save"
                            @goBack="goBack"
                        />
                    </CForm>
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Pushes from '@/components/dictionaries/Pushes';
    import { BUSINESS_TYPE } from '@/utils/order';

    export default {

        name: 'EntityDictionary',
        components: {
            Pushes,
        },

        data: () => ({
            pushes: {},
            BUSINESS_TYPE
        }),

        computed: {},

        async mounted() {
            this.pushes = (await this.axios.get(`/default-settings/pushes/${BUSINESS_TYPE.RESTAURANT}`)).data;
        },

        methods: {
            async save(pushes) {
                try {
                    pushes.entity_type = BUSINESS_TYPE.RESTAURANT;
                    await this.axios.post('/default-settings/pushes', pushes);
                    this.goBack();
                } catch (error) {
                    this.$root.$emit('showError', 'Ошибка сохранения.');
                }
            },
            goBack() {
                this.$router.push({ path: '/settings/restaurants' });
            },
        },
    };
</script>
